// extracted by mini-css-extract-plugin
export default {"section":"HowItWorks_section__K9ENS","heading":"HowItWorks_heading__orG0Q","grid":"HowItWorks_grid__2xT6O","step":"HowItWorks_step__4HTMP","number":"HowItWorks_number__yVjTi"};